<template>
  <div class="modal fade" id="addUserRole" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
     <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="exampleModalLabel">Add User</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <label class="form-label pt-2">Users</label>
              <!--
              <select class="form-select" v-model="selectedUser" placeholder="Please select " multiple>
                <option value="" disabled selected>Please Select a User</option>
                <option  v-for="item in userList" :key="item.id"  selected :value="item.id">
                  {{ item.fullName}}
                </option>
              </select>-->
              <v-select multiple v-model="selectedUser" :options="userList" label="fullName" :reduce="userList => userList.id"
                        placeholder="Please Select a Users"/>

            </div>
            <div class="modal-footer">
              <button class="btn" @click="TryAddUser()" data-bs-dismiss="modal" style="background-color: #56759c;color: #ffffff">
                <font-awesome-icon icon="save"/>
                <span class="mx-1">Save</span>
              </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
    import {mapActions, mapState} from "vuex"
    import vSelect from "vue-select";

    export default {
        name: "AddUserRole",
        props: ['isActiveUserRoleModal', 'projectId', 'roleId','userId'],
        components:{
          vSelect
        },
        data() {
            return {
                projectRoleForm: {
                    id: 0,
                    projectId: 0,
                    roleId:0,
                    userId:0
                },
                //selectedUserId: 0,
                //selectedUsers: [],
                selectedUser: ""
            }
        },
        computed: {
            ...mapState('roles', ['roles']),
            ...mapState('projects', ['userProject']),
          ...mapState('users' , ['userList']),
        },
        methods: {
           ...mapActions('users', ["getUsers"]),
            ...mapActions('roles', ['addRole', 'getRolesOfProject', 'addUserRole']),
          ...mapActions('projects', ['getProjects', 'getProject', 'getUserProject', 'addUserProject', 'addProject', 'openCloseProjectModal', 'deleteUser']),

            openCloseUserRoleModal() {
                console.log(this.userList)
                console.log("this.userList")
                this.projectRoleForm.roleName = "";
                this.$emit('openCloseUserRoleModal');
            },
            async TryAddUser() {
                try {

                    console.log(this.userId)
                    await this.addUserRole({userId:this.selectedUser,roleId:this.roleId})
                    await this.getUserProject(this.projectRoleForm.projectId);
                    await this.openCloseUserRoleModal();
                    this.$notify({title: "Success", type: "success", text: "Successfully added users."})
                } catch (e) {
                    this.$notify({title: "Error", type: "error", text: e})
                }
            },
        },
        mounted() {
          console.log(this.userList)

          document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27)//ESC
                {
                    this.isActiveUserRoleModal = false;
                }
            })
        },
      created() {
          this.getUsers();
      }
    }
</script>

<style scoped>
  .modal-footer{
    background-color: #eff1f3;
  }
</style>
